<template>
    <ul class="form_list">
        <li class="title">
            예약 변경 기간
            <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
            <span class="tooltip_wrap">
                <span class="tooltip">고객이 앱을 통해 예약을 변경할 수 있습니다.</span>
            </span>
        </li>
        <li class="cont">
            <div class="w_full">
                <label class="radio_wrap">
                    <input type="radio" name="canModify" :value="false" v-model="isUsing" :disabled="!isActive" />
                    <span class="checkmark"></span>
                    불가
                </label>
                <label class="radio_wrap">
                    <input type="radio" name="canModify" :value="true" v-model="isUsing" :disabled="!isActive" />
                    <span class="checkmark"></span>
                    가능
                </label>
            </div>
            <div class="mgt_10">
                예약일 기준
                <select class="input_xs" v-model="range" :disabled="!isActive || !isUsing">
                    <option v-for="v in optionMaxValue" :key="v" :value="v">{{ v }}</option>
                </select>
                <select class="input_xs" v-model="type" :disabled="!isActive || !isUsing">
                    <option :value="'day'">일</option>
                    <option :value="'hour'">시간</option>
                </select>
                이내 변경 불가
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        isActive: Boolean,
        canModify: Boolean,
        canModifyType: String,
        possibleModifyRange: Number
    },
    data() {
        return {
            isUsing: false,
            type: '',
            range: undefined
        }
    },
    watch: {
        canModify: {
            immediate: true,
            handler: function (newValue) {
                this.isUsing = newValue ?? false
            }
        },
        canModifyType: {
            immediate: true,
            handler: function (newValue) {
                this.type = newValue
            }
        },
        isUsing: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (newValue == oldValue) {
                    return
                }
                this.updateValue('canModify', newValue)
            }
        },
        type: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (oldValue == undefined) {
                    this.range = this.possibleModifyRange
                } else {
                    this.range = Math.min(this.range, this.optionMaxValue)
                    this.updateValue('canModifyType', newValue)
                }
            }
        },
        range: {
            handler: function(newValue) {
                this.updateValue('possibleModifyRange', Number(newValue))
            }
        }
    },
    computed: {
        optionMaxValue: function () {
            return this.type == 'hour' ? 24 : 31
        }
    },
    methods: {
        updateValue(key, value) {
            let data = {
                key: key,
                value: value
            }
            this.$emit('updateValue', data)
        }
    }
}
</script>
